import React from 'react';

import ParentDashboard from './Dashboard/ParentsDashboard';
import ParentBookList from './Books/ParentBookList';
import MyReservations from './Reservations/MyReservations';
import ParentIssuedBooks from './Issues/ParentIssuedBooks';
import ParentFineList from './Fines/ParentFineList';
import ParentPaymentList from './Payments/ParentPaymentList';
import ParentPaymentCallback from './Payments/ParentPaymentCallback';
import ParentLibraryCard from './LibraryCard/ParentLibraryCard';
import ParentProfile from './Profile/ParentProfile';

export const parentRoutes = [
  {
    path: '/parent-dashboard',
    element: <ParentDashboard />
  },
  {
    path: '/parent-book-list',
    element: <ParentBookList />
  },
  {
    path: '/parent-requests',
    element: <MyReservations />
  },
  {
    path: '/parent-issued-books',
    element: <ParentIssuedBooks />
  },
  {
    path: '/parent-fines',
    element: <ParentFineList />
  },
  {
    path: '/parent-payments',
    element: <ParentPaymentList />
  },
  {
    path: '/parent-payment-callback',
    element: <ParentPaymentCallback />
  },
  {
    path: '/parent-library-card',
    element: <ParentLibraryCard />
  },
  {
    path: '/parent-profile',
    element: <ParentProfile />
  },

  // Old route alias
  {
    path: '/parent-issue-book',
    element: <ParentIssuedBooks />
  }
];